export default __webpack_public_path__ + "static/media/taobao.3c0e5bbb.png";